import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { OiqLayoutService } from '@oiq-layout/layout.service';
import moment from 'moment';
import { OiqNotificationEventsService } from '../events/events.service';
import { OiqNotificationFormComponent } from './notification-form.component';

@Component({
  selector: 'oiq-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  imports: [OiqNotificationFormComponent],
  encapsulation: ViewEncapsulation.None,
})
export class OiqLayoutNotificationDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(OiqNotificationFormComponent)
  ctrlRef!: OiqNotificationFormComponent;

  formatter = (x: { name: string }) => x.name;

  constructor(
    public dialogRef: DialogRef<any, OiqLayoutNotificationDialogComponent>,
    private calendarService: OiqNotificationEventsService,
    private router: Router,
    private layout: OiqLayoutService,
    @Inject(DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    this.ctrlRef.form.fromResponse(this.data);
    this.ctrlRef.entitySearchStore.entityData = {
      id: this.data ? this.data.entityId : null,
      name: this.data ? this.data.entityName : null,
    };
    this.ctrlRef.form.selectEntity({
      id: this.data ? this.data.entityId : null,
      name: this.data ? this.data.entityName : null,
    });
  }

  ngOnInit() {}

  closeDialog(closeNotifications: boolean) {
    this.dialogRef.close(closeNotifications);
  }

  onSubmit() {
    let form = undefined;
    if (this.ctrlRef.form.invalid) {
      this.ctrlRef.form.markAllAsTouched();
      return;
    }

    form = this.ctrlRef.form.toPayload;

    form.userId = this.data.user.id;

    this.calendarService.createOrUpdate(form).subscribe((r: any) => {
      if (this.data.id) {
        // reminder 1 update
        if (form.interval !== this.data.calendarReminders[0].interval) {
          let data = {
            reminderRead: false,
            interval: form.interval,
            unit: 'Minutes',
            calendarEntryId: this.data.id,
          };
          this.calendarService
            .updateCalendarReminder(
              this.data.calendarReminders[0].calendarEntryId,
              this.data.calendarReminders[0].id,
              data
            )
            .subscribe((r: any) => {});
        }
        // reminder 2 update or delete or create
        if (this.data.calendarReminders[1]) {
          // update or delete
          if (form.interval2 !== '') {
            // reminder 2 update
            if (form.interval2 !== this.data.calendarReminders[1].interval) {
              let data = {
                reminderRead: false,
                interval: form.interval2,
                unit: 'Minutes',
                calendarEntryId: this.data.id,
              };
              this.calendarService
                .updateCalendarReminder(
                  this.data.calendarReminders[1].calendarEntryId,
                  this.data.calendarReminders[1].id,
                  data
                )
                .subscribe((r: any) => {});
            }
          } else {
            // delete calendar reminder
            this.calendarService
              .deleteCalendarReminder(this.data.id, this.data.calendarReminders[1].id)
              .subscribe();
          }
        } else {
          // reminder 2 create
          let data = {
            reminderRead: false,
            interval: form.interval2,
            unit: 'Minutes',
            calendarEntryId: this.data.id,
          };
          this.calendarService.createCalendarReminder(this.data.id, data).subscribe((r: any) => {});
        }
      }
      this.dialogRef.close();
    });
  }

  getFormatFromNow(datetime) {
    var timedifference = new Date().getTimezoneOffset();
    return moment(datetime).utcOffset(timedifference).fromNow();
  }

  viewEntity(row) {
    if (row.entityType && row.entityId) {
      this.router.navigate([row.entityType, row.entityId, '/overview']);
    }
  }
}
